import React, { useEffect, useState } from 'react';

import { Container } from './styles';

const Performance: React.FC = () => {
  const [user, setUser] = useState<string | null>(null);
  const [urlIframe, setUrlIframe] = useState('');

  const { hostname } = window.location;

  useEffect(() => {
    if (hostname === 'organizador.koro.com.br') {
      setUrlIframe(
        `https://report.koro.com.br/?idOrg=${
          user && JSON.parse(user).organizersUsers[0].organizer_id
        }`
      );
    } else {
      setUrlIframe(
        `https://s3.us-east-1.amazonaws.com/cdn.koro.com.br/html/Report_Koro_novo.html?idOrg=${
          user && JSON.parse(user).organizersUsers[0].organizer_id
        }`
      );
    }
  }, [hostname, user]);

  useEffect(() => {
    const storedUser = localStorage.getItem('@Koro:user');
    setUser(storedUser);
  }, []);
  return (
    <Container>
      <iframe title="Performance" width="100%" height="100%" src={urlIframe} />
    </Container>
  );
};

export default Performance;
